import { useCallback, useState } from 'react';
import { authService } from '@resort-os/api-client';

export function usePinVerification() {
  const [pin, setPin] = useState('');
  const [verifying, setVerifying] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const resetPin = useCallback(() => {
    setPin('');
    setError(null);
    setVerifying(false);
  }, []);

  const clearError = useCallback(() => setError(null), []);

  const verifyPin = useCallback(async (): Promise<boolean> => {
    const trimmed = pin.replace(/\D/g, '').trim();
    if (!trimmed) return false;

    setVerifying(true);
    setError(null);
    try {
      await authService.verifyPin(trimmed);
      setVerifying(false);
      return true;
    } catch {
      setVerifying(false);
      setError('Invalid PIN');
      return false;
    }
  }, [pin]);

  return {
    pin,
    setPin,
    verifying,
    error,
    resetPin,
    clearError,
    verifyPin,
    hasPin: Boolean(pin.replace(/\D/g, '').trim()),
  };
}
